import { useTeamMemberContacts } from "src/recoil/hooks/screens/contact/useTeamMemberContacts"

export const useContactScheduleAnswerOverviewData = (contactId: string) => {
  const { scheduleAnswerOverviews, isLoading } = useTeamMemberContacts(contactId)
  return { scheduleAnswerOverviews, isLoading }
}
